import { styled } from '@mui/material/styles';
import { ButtonBase } from '@mui/material';


export const SimButton1 = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'aninationName',
})(({ aninationName, theme }) => ({
  padding: theme.spacing(3),
  color: '#000',
  transition: 'all .3s',
  backgroundImage: `linear-gradient(90deg, #FFFFFF00 50%, #fff 50%)`,
  backgroundPosition: 'right bottom',
  backgroundSize: '200% 100%',
  backgroundRepeat: 'no-repeat',
  '&:hover': {
    backgroundPosition: 'left bottom',
  },
}));

export const SimButton2 = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'aninationName',
})(({ aninationName, theme }) => ({
  padding: theme.spacing(3),
  color: '#000',
  '&:after': {
    content: '""',
    width: '100%',
    height: 2,
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: theme.palette.action.selected,
    transform: 'scaleX(0)',
    transition: 'all .5s ease',
    transformOrigin: '50% 0%',
  },
  '&:hover': {
    '&:after': {
      transform: 'scaleX(1)'
    }
  },
}));


export { default as  ButtonPrimary } from './ButtonPrimary';
export { default as  ButtonInherit } from './ButtonInherit';
export { default as  ButtonBack } from './ButtonBack';
export { default as  ButtonText } from './ButtonText';
export { default as  ButtonAction } from './ButtonAction';
export { default as  ButtonDownload } from './ButtonDownload';
export { default as  TypographyCheck } from './TypographyCheck';
export { default as  TypographyRead } from './TypographyRead';
export { default as  TypographyLink } from './TypographyLink';
